<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive signal-table">
        <table class="table">
          <thead>
            <tr>
              <th class="text-center" scope="col">Nro</th>
              <th class="text-center" scope="col">Nombre Completo</th>
              <th class="text-center" scope="col">Documento</th>
              <th class="text-center" scope="col">Departamento</th>
              <th class="text-center" scope="col">Tipo</th>
              <th class="text-center" scope="col">Activo</th>
              <th class="text-center" scope="col">Creado el</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="paginatedItems.length === 0">
              <td colspan="7">
                <EmptyState
                  title="No hay participantes registrados."
                  :size="450"
                  fontSize="fs-5"
                />
              </td>
            </tr>
            <tr v-else v-for="(user, index) in paginatedItems" :key="user.id">
              <th class="text-center" scope="row">
                {{ (currentPage - 1) * itemsPerPage + index + 1 }}
              </th>
              <td class="text-center">{{ user.name_complete }}</td>
              <td class="text-center">{{ user.document }}</td>
              <td class="text-center">{{ user.departament }}</td>
              <td class="text-center">{{ user.tipo }}</td>
              <td>
                <div class="media-body icon-state switch-outline text-center">
                  <label class="switch">
                    <input
                      type="checkbox"
                      @change="changeStatusUser(user.id)"
                      :checked="user.has_access"
                    />
                    <span class="switch-state bg-primary"></span>
                  </label>
                </div>
              </td>
              <td class="text-center">{{ formatDate(user.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <pagination
          class="card"
          style="padding-bottom: 10px"
          :totalItems="users.length"
          :itemsPerPage="itemsPerPage"
          @page-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Pagination from "@/pages/components/Pagination.vue";
import { ref, computed } from "vue";
import EmptyState from "@/components/emptyState.vue";

const props = defineProps({ users: Array });
const emit = defineEmits(["change-status"]);

const currentPage = ref(1);
const itemsPerPage = ref(10);
const loading = ref(false);

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return props.users.slice(start, start + itemsPerPage.value);
});

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}
function handlePageChange(page) {
  currentPage.value = page;
}

function changeStatusUser(id) {
  emit("change-status", id);
}
</script>
